import { MrbBaseRouteStore } from "mrb/core";

class UserSubscriptionsPreviewRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default UserSubscriptionsPreviewRouteStore;
